"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const PushNotificationTypes_1 = require("./pushNotification/PushNotificationTypes");
const pushAPITypes_1 = require("./pushapi/pushAPITypes");
const pushStreamTypes_1 = require("./pushstream/pushStreamTypes");
const space_1 = require("./space");
const types_1 = require("./types");
const video_1 = require("./video");
// TODO: Change this do . type
// TODO: Add Notif type.
// TODO: Add Notif settings, boolean and slider
// TODO: Notification alias chain
const CONSTANTS = {
    ENV: constants_1.ENV,
    STREAM: pushStreamTypes_1.STREAM,
    CHAT: {
        LIST_TYPE: pushAPITypes_1.ChatListType,
        MESSAGE_TYPE: constants_1.MessageType,
        GROUP: {
            RULES: {
                CONDITION_TYPE: types_1.ConditionType,
                CATEGORY: types_1.GROUP_RULES_CATEGORY,
                SUBCATEGORY: types_1.GROUP_RULES_SUB_CATEGORY,
                PERMISSION: types_1.GROUP_RULES_PERMISSION,
                INVITER_ROLE: types_1.GROUP_INVITER_ROLE,
            },
        },
    },
    VIDEO: {
        EVENT: pushStreamTypes_1.VideoEventType,
        STATUS: types_1.VideoCallStatus,
        INITIAL_DATA: video_1.initVideoCallData,
    },
    SPACE: {
        EVENT: pushStreamTypes_1.SpaceEventType,
        INITIAL_DATA: space_1.initSpaceData,
    },
    ALPHA_FEATURES: constants_1.ALPHA_FEATURES,
    USER: { ENCRYPTION_TYPE: constants_1.ENCRYPTION_TYPE },
    NOTIFICATION: {
        TYPE: types_1.NotifictaionType,
        CHANNEL: {
            LIST_TYPE: PushNotificationTypes_1.ChannelListType,
        },
    },
    FILTER: {
        CHANNEL_LIST: {
            SORT: PushNotificationTypes_1.ChannelListSortType,
            ORDER: PushNotificationTypes_1.ChannelListOrderType,
        },
        NOTIFICATION_TYPE: types_1.NotifictaionType,
    },
};
exports.default = CONSTANTS;
//# sourceMappingURL=constantsV2.js.map